import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import converter from './converter';
import * as api from './api';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getUnitMeasurements.toString(),
            defaultSaga({
                constants: constants.getUnitMeasurements,
                api: api.getUnitMeasurements
            })
        ),
        yield takeLatest(
            constants.getUnitMeasurement.toString(),
            defaultSaga({
                constants: constants.getUnitMeasurement,
                api: api.getUnitMeasurement
            })
        )
    ]);
}